import React, { useEffect, useState } from 'react';
import { Box, TextField } from '@mui/material';

import { globalClasses } from '../../utils/globalUtils';
import CheckIcon from '../../../../assets/allInvoice-assets/check.svg';
import CloseIcon from '../../../../assets/allInvoice-assets/x.svg';
import Toast from '../../utils/Toast';
import { classes } from './utils';

const UpdateColumnData = (
  currentValue,
  mergedData,
  field,
  selectedVersion,
  id,
  updateOpenedData,
  setIsEdited,
  title,
  rowIndex,
) => {
  mergedData.forEach((d) => {
    if (d.label === title && d.id === id) {
      const modifiedData = d;
      modifiedData.value = currentValue;
      modifiedData.validated = true;
      modifiedData.version = selectedVersion;
      modifiedData.label = title;
      modifiedData.short_desc = field;
      updateOpenedData(d);
      setIsEdited(true);
    }
  });
  if (currentValue !== '') {
    const isColumnAvailable = mergedData.some(
      (d) => d.short_desc === field && d?.product && d.product === rowIndex + 1,
    );
    if (!isColumnAvailable) {
      const modifiedItem = {
        value: currentValue,
        validated: true,
        label: title,
        short_desc: field,
        product: rowIndex + 1,
        version: selectedVersion,
        id: Math.random().toString(36).substring(2, 8),
      };
      updateOpenedData(modifiedItem);
      setIsEdited(true);
    }
  }
};
const CellEditor = (params) => {
  const { colDef, mergedData, updateOpenedData, selectedVersion, setIsEdited } =
    params;
  const value = params?.data[colDef.title]
    ? params?.data[colDef.title].value
    : '';
  const [currentValue, setCurrentValue] = useState(value);
  const [enterPressed, setEnterPressed] = useState(false);

  const [id, setId] = useState('');
  const handleCancel = () => {
    params?.api.stopEditing();
  };

  const handleChange = (e) => {
    setCurrentValue(e.target.value);
    setEnterPressed(false);
  };
  const handleSave = async () => {
    try {
      await UpdateColumnData(
        currentValue,
        mergedData,
        colDef.headerName,
        selectedVersion,
        id,
        updateOpenedData,
        setIsEdited,
        colDef.title,
        params.rowIndex,
      );
      params?.api.purgeInfiniteCache();
      params?.api.stopEditing();
      setIsEdited(false);
      Toast({
        message: `${colDef.headerName} Successfully Updated`,
        variant: 'success',
      });
    } catch (error) {
      Toast({
        message: error,
        variant: 'error',
      });
    }
  };
  const handleEnterKey = async (event) => {
    try {
      if (event.key === 'Enter' && !enterPressed) {
        setEnterPressed(true);
        await UpdateColumnData(
          event.target.value,
          mergedData,
          colDef.headerName,
          selectedVersion,
          id,
          updateOpenedData,
          setIsEdited,
          colDef.title,
          params.rowIndex,
        );
        params?.api.purgeInfiniteCache();
        params?.api.stopEditing();
        setIsEdited(false);
        setEnterPressed(false);
        Toast({
          message: `${colDef.headerName} Successfully Updated`,
          variant: 'success',
        });
      }
    } catch (error) {
      Toast({
        message: error,
        variant: 'error',
      });
    }
  };
  const handleTextFieldFocus = () => {
    const textField = document.querySelector('.editCellTextfield');
    textField.addEventListener('keydown', handleEnterKey);
  };
  useEffect(() => {
    if (mergedData && mergedData.length > 0) {
      mergedData.forEach((d) => {
        if (
          d?.product === params?.data[colDef.title]?.product &&
          d?.label === colDef.title &&
          d?.id === params?.data[colDef.title]?.id
        ) {
          setId(d?.id);
        }
      });
    }
  }, []);
  return (
    <Box className={classes.documentEditCellBox}>
      {colDef.title === 'Description' ? (
        <TextField
          fullWidth
          // multiline
          // minRows={3}
          // maxRows={6}
          value={currentValue}
          onChange={handleChange}
          className={classes.editCellTextfield}
          // inputProps={{ maxLength: 1000 }}
          onFocus={handleTextFieldFocus}
        />
      ) : (
        <TextField
          fullWidth
          value={currentValue}
          className={classes.editCellTextfield}
          onChange={handleChange}
          onFocus={handleTextFieldFocus}
        />
      )}

      <Box className={classes.editCellActionIcons}>
        <Box
          component="img"
          src={CheckIcon}
          alt="CheckIcon"
          className={`${classes.editIcon} ${globalClasses.visibility}`}
          onClick={() => {
            handleSave(mergedData);
          }}
        />
        <Box
          component="img"
          src={CloseIcon}
          alt="CloseIcon"
          className={classes.editIcon}
          onClick={handleCancel}
        />
      </Box>
    </Box>
  );
};

export default CellEditor;
